export default {
  title: {
    action: {
      create: "Add",
      update: "Update",
    },
  },
  button: {
    save: "Save",
    search: "Search",
    cancel: "Cancel",
  }
}
